import { render, staticRenderFns } from "./AlumniStories.vue?vue&type=template&id=24973f13"
import script from "./AlumniStories.vue?vue&type=script&lang=js"
export * from "./AlumniStories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports